export const CARTE_RESET = "CARTE_RESET";
export const CARTE_SET_ERROR = "CARTE_SET_ERROR";
export const CARTE_SET_ITEMS = "CARTE_SET_ITEMS";
export const CARTE_TOGGLE_LOADING = "CARTE_TOGGLE_LOADING";
